import type { IconType } from "@/react/components/shared/Icon";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface ActionButtonProps {
  iconName: IconType;
  onClick: () => void;
  text: string;
}

export const ActionButton = ({
  iconName,
  text,
  onClick,
}: ActionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="focus:ring-secondary-200 hover:bg-secondary border-primary bg-primary text-dark flex h-[44px] items-center gap-2 rounded-xl border px-4 py-3 shadow-sm focus:outline-none focus:ring-2"
  >
    <Icon
      type={iconName}
      className="text-grey-900 dark:text-grey-50"
      size={20}
    />
    <Typography.BodySm color="text-secondary" weight="font-medium">
      {text}
    </Typography.BodySm>
  </button>
);
